//! @ngInject
export function billingRateSetupModalCtrl($scope, fields, data, FormService, DatabaseApi, toaster, $rootScope, $uibModal, NgTableParams, Currency) {
    $scope.hideSaveFormButton = true;
    $scope.title = $scope.viewModeOnly ? "View rate" : "Add rate";
    $scope.fields = FormService.getFields(fields, data, $scope.viewModeOnly);
    $scope.data = data;
    $scope.form = {};
    $scope.changedBillingRateCounties = new Set();
    $scope.billingRateGroups = [];
    $scope.countySearch = '';

    buildBillingRateGroups();

    function buildBillingRateGroups() {
        const locationsIdsMap = $scope.locationGroups.reduce(function (map, obj) {
            map[obj.id] = obj;
            return map;
        }, {});

        const existingRates = ($scope.data && $scope.data.rates) ? $scope.data.rates : [];
        const groupsMap = {};

        $scope.counties.forEach(function (county) {
            const group = locationsIdsMap[county.locationGroupId];
            if (!group) return;

            const existingRate = existingRates.find(function (r) {
                return r.countyName === county.countyName && r.state === county.state;
            });

            // In viewMode we PUT updates to existing billing_rate_counties rows.
            // Counties without an existing rate row can't be saved through that
            // endpoint, so skip them rather than showing inputs whose edits
            // would be silently discarded.
            if ($scope.viewModeOnly && !existingRate) return;

            if (!groupsMap[group.id]) {
                groupsMap[group.id] = {
                    id: group.id,
                    name: group.name,
                    rateInCents: null,
                    weekendRateInCents: null,
                    isExpanded: false,
                    counties: []
                };
            }

            groupsMap[group.id].counties.push({
                id: existingRate ? existingRate.id : null,
                countyName: county.countyName,
                state: county.state,
                locationGroupId: county.locationGroupId,
                groupName: group.name,
                rateInCents: existingRate ? existingRate.rateInCents : null,
                weekendRateInCents: existingRate
                    ? (existingRate.weekendRateInCents != null ? existingRate.weekendRateInCents : existingRate.rateInCents)
                    : null,
                emednyEDILocationCode: existingRate ? existingRate.emednyEDILocationCode : null,
                emednyEDIRateCode: existingRate ? existingRate.emednyEDIRateCode : null
            });
        });

        $scope.billingRateGroups = Object.values(groupsMap);
        $scope.billingRateGroups.forEach(function (group) {
            group.rateInCents = uniformValueOrNull(group.counties, 'rateInCents');
            group.weekendRateInCents = uniformValueOrNull(group.counties, 'weekendRateInCents');
        });
    }

    function uniformValueOrNull(items, field) {
        if (!items.length) return null;
        const first = items[0][field];
        if (first === null || first === undefined || first === '') return null;
        for (let i = 1; i < items.length; i++) {
            if (items[i][field] !== first) return null;
        }
        return first;
    }

    $scope.toggleGroup = function (group) {
        group.isExpanded = !group.isExpanded;
    };

    $scope.hasCountySearch = function () {
        return !!($scope.countySearch && $scope.countySearch.trim());
    };

    $scope.countyMatchesSearch = function (county) {
        if (!$scope.hasCountySearch()) return true;
        const query = $scope.countySearch.trim().toLowerCase();
        const text = (county.countyName + ' ' + (county.state || '')).toLowerCase();
        return text.indexOf(query) !== -1;
    };

    $scope.groupHasMatchingCounties = function (group) {
        if (!$scope.hasCountySearch()) return true;
        return group.counties.some($scope.countyMatchesSearch);
    };

    $scope.clearCountySearch = function () {
        $scope.countySearch = '';
    };

    $scope.getGroupRatePlaceholder = function (group, field) {
        const values = group.counties
            .map(function (c) { return c[field]; })
            .filter(function (v) { return v !== null && v !== undefined && v !== ''; })
            .map(Number)
            .filter(function (v) { return !isNaN(v); });

        if (values.length === 0) {
            return 'Enter a rate';
        }

        const min = Math.min.apply(null, values);
        const max = Math.max.apply(null, values);

        if (min === max) {
            return formatMoney(min);
        }

        return formatMoney(min) + ' - ' + formatMoney(max);
    };

    function formatMoney(value) {
        return Number(value).toFixed(2);
    }

    $scope.$watch('countySearch', function (newValue, oldValue) {
        if (newValue === oldValue) return;
        if (!newValue || !newValue.trim()) return;
        // Auto-expand any group that has matching counties so the user
        // can see the matches, but leave the manual toggle in control.
        $scope.billingRateGroups.forEach(function (group) {
            if ($scope.groupHasMatchingCounties(group)) {
                group.isExpanded = true;
            }
        });
    });

    $scope.onGroupRateChange = function (group) {
        group.counties.forEach(function (county) {
            if (county.rateInCents !== group.rateInCents) {
                county.rateInCents = group.rateInCents;
                markCountyChanged(county);
            }
        });
    };

    $scope.onGroupWeekendRateChange = function (group) {
        group.counties.forEach(function (county) {
            if (county.weekendRateInCents !== group.weekendRateInCents) {
                county.weekendRateInCents = group.weekendRateInCents;
                markCountyChanged(county);
            }
        });
    };

    $scope.onCountyRateChange = function (group, county) {
        markCountyChanged(county);
        group.rateInCents = uniformValueOrNull(group.counties, 'rateInCents');
    };

    $scope.onCountyWeekendRateChange = function (group, county) {
        markCountyChanged(county);
        group.weekendRateInCents = uniformValueOrNull(group.counties, 'weekendRateInCents');
    };

    $scope.onCountyFieldChange = function (county) {
        markCountyChanged(county);
    };

    function markCountyChanged(county) {
        if (county.id != null) {
            $scope.changedBillingRateCounties.add(county.id);
        }
    }

    function getAllCounties() {
        return $scope.billingRateGroups.reduce(function (acc, group) {
            return acc.concat(group.counties);
        }, []);
    }

    $scope.saveRate = function () {
        if ($scope.viewModeOnly) {
            savePutChangedCounties();
        } else {
            savePostNewRate();
        }
    };

    function savePutChangedCounties() {
        const allCounties = getAllCounties();
        const editedCounties = allCounties.filter(function (c) {
            return $scope.changedBillingRateCounties.has(c.id);
        });

        if (editedCounties.length === 0) {
            $scope.$close();
            return;
        }

        for (const county of editedCounties) {
            if (county.rateInCents === null || county.rateInCents === undefined || county.rateInCents === '') {
                toaster.pop('error', "Something went wrong", "Please fill in a rate for each county");
                return;
            }
        }

        const billingRateCounties = editedCounties.map(function (c) {
            return {
                id: c.id,
                countyName: c.countyName,
                state: c.state,
                groupName: c.groupName,
                rateInCents: new Currency().fromMajor(c.rateInCents != null ? c.rateInCents : 0).toMinor(),
                weekendRateInCents: new Currency().fromMajor((c.weekendRateInCents != null ? c.weekendRateInCents : c.rateInCents) || 0).toMinor(),
                emednyEDILocationCode: c.emednyEDILocationCode,
                emednyEDIRateCode: c.emednyEDIRateCode
            };
        });

        DatabaseApi.put('agencies/' + $rootScope.agencyId + '/billing_rate_counties', { billingRateCounties: billingRateCounties }).then(function (res) {
            $scope.changedBillingRateCounties = new Set();
            $scope.getRates();
            $scope.$close();
            toaster.pop('success', "rate counties values was saved");
        }, function (err) {
            $scope.changedBillingRateCounties = new Set();
            toaster.pop('error', "Something went wrong", "Could not edit rate counties values");
        });
    }

    function savePostNewRate() {
        $scope.form.data.$submitted = true;

        if (!validateRateForm()) {
            return;
        }

        $uibModal.open({
            templateUrl: 'admin/views/update-invoice-rates-modal.html',
            size: 'md',
            controller: 'updateInvoiceRatesModalCtrl',
            windowTopClass: "boost-modal"
        }).result.then(function (modalResult) {
            if (modalResult !== 'discard') {
                $scope.updateExistingInvoiceRatesData = modalResult;
            }

            const formData = FormService.prepareFormData($scope.fields);
            const billingRateRequest = prepareBillingRateRequest(formData);

            DatabaseApi.post('agencies/' + $rootScope.agencyId + '/billing_rates', billingRateRequest).then(function (res) {
                if (res.data.visitWithIssues && res.data.visitWithIssues.length > 0) {
                    toaster.pop('error', "Visits with issues", "The following visit IDs have issues and won't be updated \n" + res.data.visitWithIssues.join(', '), { timeOut: 20000 });
                }
                $scope.getRates();
                $scope.$close();
                toaster.pop('success', "A new rate was saved");
            }, function (err) {
                toaster.pop('error', "Something went wrong", "Could not add a new rate");
            });
        });
    }

    function validateRateForm() {
        if ($scope.form.data.$invalid) {
            return false;
        }

        const allCounties = getAllCounties();
        for (const county of allCounties) {
            if (county.rateInCents === null || county.rateInCents === undefined || county.rateInCents === '') {
                toaster.pop('error', "Something went wrong", "Please fill in a rate for each county");
                return false;
            }
        }

        return true;
    }

    function prepareBillingRateRequest(formData) {
        formData.contractType = $scope.contractId;

        const countyRates = [];
        const existingRates = ($scope.data && $scope.data.rates) ? $scope.data.rates : [];

        $scope.billingRateGroups.forEach(function (group) {
            group.counties.forEach(function (county) {
                const previousRate = existingRates.find(function (cr) {
                    return cr.countyName === county.countyName && cr.state === county.state;
                });

                countyRates.push({
                    countyName: county.countyName,
                    state: county.state,
                    groupName: group.name,
                    rateInCents: new Currency().fromMajor(county.rateInCents != null ? county.rateInCents : 0).toMinor(),
                    weekendRateInCents: new Currency().fromMajor((county.weekendRateInCents != null ? county.weekendRateInCents : county.rateInCents) || 0).toMinor(),
                    emednyEDILocationCode: county.emednyEDILocationCode != null ? county.emednyEDILocationCode : (previousRate ? previousRate.emednyEDILocationCode : undefined),
                    emednyEDIRateCode: county.emednyEDIRateCode != null ? county.emednyEDIRateCode : (previousRate ? previousRate.emednyEDIRateCode : undefined)
                });
            });
        });

        if ($scope.updateExistingInvoiceRatesData) {
            formData.updateExistingInvoiceRatesData = $scope.updateExistingInvoiceRatesData;
        }

        formData.billingRateCounties = countyRates;
        return formData;
    }

    function setHistoryTableData() {
        const options = {
            count: 5,
            sorting: { createdAt: "desc" }
        };

        $scope.historyTableData = new NgTableParams(options, {
            counts: [],
            dataset: $scope.rateHistory
        });
    }

    setHistoryTableData();
};
